import Loader from "../DomUtilities/Loader";
import openErrorModal from "../Error/ErrorModal";
import { fetchEConomicForm } from "../HTTPRequests/StoreRequests";

export default class EConomicForm {
	private htmlString: string;
	formWrapper: HTMLDivElement;
	parentContainer: HTMLDivElement;
	readonly FORM_LENGTH: number = 310;

	public init(parentContainer: HTMLDivElement, wrapper: HTMLDivElement) {
		this.formWrapper = wrapper;
		this.parentContainer = parentContainer;
	}

	public toggleForm(checked: boolean) {
		if (this.htmlString) {
			this.dispalyForm(checked);
		} else {
			this.fetchForm(checked);
		}
	}

	public destroy() {
		this.htmlString = null;
	}

	private async fetchForm(isVisible: boolean) {
		Loader.show();
		fetchEConomicForm()
			.then((response: string) => {
				this.htmlString = response;
				this.dispalyForm(isVisible);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	}

	private dispalyForm(isVisible: boolean) {
		if (isVisible) {
			this.formWrapper.innerHTML = this.htmlString;
			this.parentContainer.scrollBy(0, this.FORM_LENGTH);
		} else {
			this.parentContainer.scrollBy(0, -this.FORM_LENGTH);
			setTimeout(() => this.formWrapper.innerHTML = "", this.FORM_LENGTH);
		}

		this.addCustomerContactListerners();
	}

	public addCustomerContactListerners() {
		const customerContactWrapper: HTMLDivElement = document.querySelector("#economic-customer-contact-wrapper");
		const customerContactCheckbox: HTMLInputElement = document.querySelector("#economic-customer-contact");

		customerContactCheckbox.onchange = () => {
			customerContactWrapper.style.display = customerContactCheckbox.checked ? "block" : "none";
		}
	}
}

